export default "/images/completed.png?6f298cca57a5a8b36055fd638fa31481";